<template>
	<div class="optionsTabDiv lcpCard">
		<div class="inner">
			<span class="filterTitle">Selected Managers</span>
			<div class="underline"><div class="underlineColour"></div></div>
			<div class="slideWrapper">
				<div class="filterDiv">
					<key-card v-for="manager in selectedManagers" :key="manager.bbIndex" :managerInfo="manager" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import keyCard from '@/components/common/uiLayouts/managerKeyCard.vue';

export default {
    name: 'comparisonSidebar',
    components: {
        keyCard,
    },
    data () {
        return {
            mainHeight: 0,
            filterArray: [],
        };
    },
    computed: {
        selectedManagers () {
            return this.sortManagers(this.$store.getters.getUnDeletedSelectedMangers, 'comparison');
        },
    },
    methods: {
        sortManagers (managers, sortStat) {
            const items = [];

            for (const ii in managers) {
                items.push({ index: ii, obj: managers[ii] });
                items[ii].obj.oIndex = ii;
            }
            // sort by value
            items.sort((a, b) => a.obj[sortStat] - b.obj[sortStat]);

            items.sort((a, b) => b.obj[sortStat] - a.obj[sortStat]);

            const out = [];

            for (const i in items) {
                managers[items[i].index].sortOrder = i;
                out.push(items[i].obj);
            }
            return out;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/all.scss";
.optionsTabDiv {
	overflow: hidden;
	padding: 20px;
	position: relative;
	.filterTitle {
		cursor: pointer;
		float: left;
		font-size: 18px;
	}
	.dimensionsTitle {
		cursor: pointer;
		float: right;
		font-size: 18px;
	}
	.underline {
		background-color: $grey;
		float: left;
		height: 2px;
		margin: 5px 0 0 0;
		position: relative;
		width: 100%;
		.underlineColour {
			background: $darkBlue;
			height: 3px;
			left: 0;
			position: absolute;
			top: 0px;
			width: 30%;
			@include easeInOut(1s);
			&.right {
				left: 70%;
			}
		}
	}
	.inner {
		@include easeInOut(0.5s);
		bottom: 10px;
		left: 20px;
		margin-top: 0;
		overflow: auto;
		position: absolute;
		right: 20px;
		top: 10px;
		&.slideUp {
			margin-top: -56px;
			min-height: 570px;
		}
	}
	.slideWrapper {
		@include easeInOut(1s);
		float: left;
		height: calc(100% - 60px);
		left: 0;
		margin-top: 20px;
		position: relative;
		width: 100% !important;
		.filterDiv,
		.dimensionsDiv {
			height: 100%;
			position: absolute;
			width: 100%;
		}
		.filterDiv {
			left: 0;
		}
	}
	.slideLeft {
		left: -105%;
	}
	.slideRight {
		left: 0;
	}
}
</style>
